import React from "react";
import { storeConfig } from "../../config/store.config";

// Editable, disable-able marquee announcement bar.
// Toggle via storeConfig.announcementEnabled / announcementText.
const AnnouncementBar = () => {
  if (!storeConfig.announcementEnabled || !storeConfig.announcementText) {
    return null;
  }
  const items = Array.from({ length: 8 }).map((_, i) => (
    <span key={i} className="flex items-center">
      <span className="label-mono text-paper/90">
        {storeConfig.announcementText}
      </span>
      <span className="mx-6 text-brand" aria-hidden="true">
        ✦
      </span>
    </span>
  ));

  return (
    <div
      className="w-full overflow-hidden bg-ink py-2.5"
      data-testid="announcement-bar"
    >
      <div className="marquee-track">
        <div className="flex shrink-0 items-center">{items}</div>
        <div className="flex shrink-0 items-center" aria-hidden="true">
          {items}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
